// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabCmpAlmacenaInfo extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.cmp_almacena_info";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabCmpAlmacenaInfo {
        this.VALUES ??= this.completar({
            "valor": {
                "ca-ES": "Emmagatzematge d’informació",
                "cz": "Ukládání informací",
                "da": "Opbevaring af oplysninger",
                "de": "Informatie-opslag",
                "en": "Information storage",
                "eu-ES": "Informazioa biltegiratzea",
                "fi": "Tietojen varastointi",
                "fr": "Stockage d\\'informations",
                "ga-ES": "Almacenamento de información",
                "hi": "सूचना भंडारण",
                "hu": "Információ tárolása",
                "it": "Conservazione dei dati",
                "nl": "Informatie-opslag",
                "no": "Informasjonslagring",
                "pl": "Przechowywanie informacji",
                "pt": "Armazenamento de informação",
                "ro": "Stocarea informațiilor",
                "ru": "Хранение информации",
                "sv": "Informationslagring",
                "sk": "Ukladanie informácií"
            },
            "defecto": "Almacenamiento de información"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
